document.querySelectorAll( '.header' ).forEach( ( node ) => {
	if ( node.classList.contains( 'header--media-fixed' ) ) {
		const media = node.querySelector( '.header__media > img, .header__media > video' );
		const resize = () => ( media.style.height = `${ media.parentNode.getBoundingClientRect().height }px` );

		resize();
		window.addEventListener( 'resize', resize );
	}
} );
